'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './violations-ticket-list.routes';

export class ViolationsTicketListComponent {
  constructor(ViolationTicketsService, ViolationCodesService, dialogs, $scope, ViewSelection, DTOptionsBuilder, $timeout,
              ChartJs, DTState, Util) {
    'ngInject';

    this.$scope = $scope;
    this.ViewSelection = ViewSelection;

    this.ViolationTicketsService = ViolationTicketsService;
    this.ViolationCodesService = ViolationCodesService;
    this.filteredData = [];
    this.data = [];
    this.selectedCommunityCode = "";
    this.visibleStatus = 'open';
    this.$timeout = $timeout;

    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Violation Tickets",
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        extend: 'csv',
        title: "Violation Tickets",
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        title: "Violation Tickets",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape', // portrait
        pageSize: 'LETTER',
        exportOptions: {
          orthogonal: 'export',
        }
      },{
        extend: 'print',
        title: "Violation Tickets",
        exportOptions: {
          orthogonal: 'export',
        }
      }]);

    this.dtOptions.columnDefs = [ {
      targets: [2, 3],
      render: Util.dataTableExportBreakToNewlineRenderer
    },{
      targets: [5],
      render: function (data, type, row) {
        if (type === 'export') {
          console.log(data);
          return data.replaceAll('<i ng-if="level.active" class="text-danger fa fa-exclamation ng-scope" ng-repeat="level in ticket.sequence"></i>','I');
        }
        return data;
      }
    } ];

    this.chartLabels = {
      'open': [],
      'total': [],
      'asn': []
    };

    this.chartOptions = {
      'open': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Open per Type'
        },
        animation: false
      },
      'total': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Total per Type'
        },
        animation: false
      },
      'asn': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Total per Community'
        },
        animation: false
      },
      'overtime': {
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          text: 'Violations Over Time'
        }
      }
    };

    this.chartColorsDefault = ChartJs.getOptions('pie').global.colors; //['#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#c5b0d5', '#8c564b', '#c49c94', '#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'];
    this.chartColors = {
      'total': [],
      'open': [],
      'asn': []
    };

    this.labelsOvertime = [
      "01/18", "02/18", "03/18", "04/18", "05/18", "06/18", "07/18", "08/18", "09/18", "10/18", "11/18", "12/18",
      "01/19", "02/19", "03/19", "04/19", "05/19", "06/19", "07/19", "08/19", "09/19", "10/19", "11/19", "12/19",
      "01/20", "02/20", "03/20", "04/20", "05/20", "06/20", "07/20", "08/20", "09/20", "10/20", "11/20", "12/20"
    ];
    this.seriesOvertime = ['Total Open','Opened This Month','Closed This Month'];

    this.ViolationCodesService.query((data) => {
      this.codes = data;
      this.chartLabels['open'] = data.map(code => code.code);
      this.chartLabels['total'] = data.map(code => code.code);
    }, err => {
      console.log("Could not retrieve violation codes.")
    });

    this.ViolationTicketsService.query((data) => {
      this.data = data;
      this.filterData(ViewSelection.selectedCommunityCode);
      this.dataInitComplete = true;

    }, err => {
      console.log("Could not retrieve violation tickets.")
    });

    $scope.ViewSelection = ViewSelection;
    $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
      this.selectedCommunity = newVal.name;
      this.selectedCommunityCode = newVal.value;
      this.filterData(this.selectedCommunityCode, this.selectedCode);
    });
  }

  buildGraphData() {
    this.dataOvertime = [[], [], []];
    this.chartData = {
      'open': [],
      'total': [],
      'asn': []
    };

    this.filteredData.forEach(ccr => {
      let creationMonth = moment(ccr.meta.creationDate).format("MM/YY");
      let indexOpen = this.labelsOvertime.findIndex(elm => elm == creationMonth);
      if (indexOpen) {
        if (!this.dataOvertime[1][indexOpen])
          this.dataOvertime[1][indexOpen] = 1;
        else
          this.dataOvertime[1][indexOpen]++;
      }

      if (ccr.closeDate) {
        let closeMonth = moment(ccr.closeDate).format("MM/YY");
        let indexClose = this.labelsOvertime.findIndex(elm => elm == closeMonth);
        if (indexClose) {
          if (!this.dataOvertime[2][indexClose])
            this.dataOvertime[2][indexClose] = -1;
          else
            this.dataOvertime[2][indexClose]--;
        }
      }
    });

    for (let i=0; i<this.labelsOvertime.length; i++) {
      if (!this.dataOvertime[0][i])
        this.dataOvertime[0][i] = 0;
      if (!this.dataOvertime[1][i])
        this.dataOvertime[1][i] = 0;
      if (!this.dataOvertime[2][i])
        this.dataOvertime[2][i] = 0;
    }

    for (let i=0; i<this.labelsOvertime.length; i++) {
      if (i==0)
        this.dataOvertime[0][0] = this.dataOvertime[0][1] - this.dataOvertime[0][2];
      else
        this.dataOvertime[0][i] = this.dataOvertime[0][i-1] + this.dataOvertime[1][i] + this.dataOvertime[2][i];
    }

    this.$timeout(_ => {
      let referenceData1 = (this.selectedCommunityCode) ? this.data.filter(ccr =>
        ccr.property && ccr.property.community && ccr.property.community.code == this.selectedCommunityCode) : this.data;
      this.chartLabels['open'].forEach(code => {
        this.chartData['open'].push( referenceData1.filter(ccr => ccr.code == code && ccr.status == 'open').length );
        this.chartData['total'].push( referenceData1.filter(ccr => ccr.code == code).length );
      });

      let referenceData2 = (this.selectedCode) ? this.data.filter(ccr => ccr.code == this.selectedCode) : this.data;
      referenceData2.forEach(ccr => {
        if (!this.chartLabels['asn'].includes(ccr.property.community.code))
          this.chartLabels['asn'].push(ccr.property.community.code);
      });
      this.chartLabels['asn'].forEach(asn => {
        this.chartData['asn'].push(referenceData2.filter(ccr => ccr.property.community.code == asn).length);
      });
    },0)
  }

  resetCodeFilter() {
    this.selectedCode = null;
    this.applyCodeFilter();
  }

  applyCodeFilter() {
    if (this.selectedCode)
      this.filterData(this.selectedCommunityCode, this.selectedCode);
    else
      this.filterData(this.selectedCommunityCode);
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryOwner(property) {
    let primary = property.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary || !primary.contact)
      return "-";

    /*
    let name = primary.contact.firstName;
    if (primary.contact.middleName)
      name += " " + primary.contact.middleName;
    name += " " + primary.contact.lastName;*/

    return this.getComposedName(primary.contact);
  }

  filterData(communityCode, ticketCode) {
    if (communityCode) {
      this.filteredData = this.data.filter(ccr => ccr.property && ccr.property.community && ccr.property.community.code == communityCode)
    } else {
      this.filteredData = this.data;
    }

    if (ticketCode) {
      this.filteredData = this.filteredData.filter(ccr => ccr.code == ticketCode);
    }

    this.buildGraphData();

    this.chartColors['asn'] = (communityCode) ? this.chartLabels['asn'].map(code => {
      let idx = this.chartLabels['asn'].indexOf(code);
      return (code == this.selectedCommunityCode) ? this.chartColorsDefault[idx] : "#eeeeee"
    }) : this.chartColorsDefault;

    this.chartColors['total'] = (ticketCode) ? this.chartLabels['total'].map(code => {
      let idx = this.chartLabels['total'].indexOf(code);
      return (code == this.selectedCode) ? this.chartColorsDefault[idx] : "#eeeeee"
    }) : this.chartColorsDefault;

    this.chartColors['open'] = this.chartColors['total'];
  }

  delete(ticket) {
    var that = this;

    var ticketText = "<br/><br/><b>" + ticket.code + ': ' + ticket.name + "</b><br/><p>" + ticket.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Violation ticket?", "Do you really want to delete the violation ticket?" + ticketText);
    dlg.result.then(() => {
      // OK delete it
      that.ViolationTicketsService.delete({id: ticket._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== ticket._id;
          });

          that.filterData(that.selectedCommunityCode);
        },
        err => {
          alert("Could not delete ticket");
        });
    }, () => {
      // Cancel
    });
  }

  getCount(cat) {
    return this.filteredData.reduce((acc, obj) => {
      return acc + (obj.status === cat);
    }, 0);
  }

  setFilter(cat) {
    this.dataInitComplete = false;
    this.visibleStatus = cat;

    this.$timeout(_ => {
      this.dataInitComplete = true;
    },0);
  }

}

export default angular.module('conduu.violationTicketList', [uiRouter])
  .config(routes)
  .component('violationTicketList', {
    template: require('./violations-ticket-list.html'),
    controller: ViolationsTicketListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/violations/ticket-list/violations-ticket-list.component.js